import { backgrounds } from "./explorationZone"
import GetModals from "./modals/exploration"

const modals = GetModals(3)
const bg = backgrounds.get(3)

const TVs = [
	{
		height: "19.6%",
		left: "2%",
		top: "30%",
		width: "16.3%",
	},
	{
		width: "16.8%",
		height: "19.6%",
		left: "41.5%",
		top: "31%",
	},
	{
		height: "21.2%",
		left: "80.5%",
		top: "30%",
		width: "17.3%",
	},
	{
		width: "21.3%",
		height: "30.6%",
		left: "3%",
		top: "57%",
	},
	{
		width: "11.3%",
		height: "24.6%",
		left: "76%",
		top: "57%",
	},
	{
		width: "9.3%",
		height: "26.6%",
		left: "41%",
		top: "59%",
	}
].map((it, idx) => {
	if (!modals || !modals.tvs[idx]) return null
	if (modals.tvs[idx].length == 0) return null;

	const [Modal, props] = modals.tvs[idx]

	return {
		...it,
		modal: <Modal />,
		label: props.name,
		modalOverrides: {
			dismissStyle: props.dismiss,
			...(props.extras || {})
		}
	}
}).filter(it => it !== null)


export default {
	background: bg.bg,
	links: [
		...TVs,
		{
			width: "13.1%",
			height: "8.2%",
			left: "43.3%",
			top: "89%",
			label: "Back to Atrium",
			href: "/atrium"
		}
	],
	name: "exploration-zone-od",
}
